import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import theme from '../../../../theme/theme';
import { SUB_HEADER } from '../../config/employeeDetailTokens';
import { EmployeeHeaderIcon } from '../EmployeeHeaderIcon';
import type { EmployeeRow } from '../../employeeTypes';

interface SubHeaderProps {
  employee: EmployeeRow;
  onBack: () => void;
}

export function SubHeader({ employee, onBack }: SubHeaderProps) {
  const { t } = useTranslation('common');

  const employeeName = [employee.file_number, employee.first_name, employee.last_name]
    .filter(Boolean)
    .join(' ');

  return (
    <Box
      sx={{
        background: SUB_HEADER.gradient,
        color: SUB_HEADER.color,
        px: 3,
        py: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <EmployeeHeaderIcon />

        <Breadcrumbs
          separator={<NavigateNextIcon sx={{ fontSize: 16, color: theme.palette.text.label }} />}
          aria-label="breadcrumb"
        >
          <Link
            component="button"
            type="button"
            variant="body2"
            onClick={onBack}
            sx={{
              fontSize: theme.typography.breadcrumbLink.fontSize,
              color: SUB_HEADER.buttonColor,
              textDecoration: 'none',
              fontWeight: theme.typography.fontWeightMedium,
              cursor: 'pointer',
              background: 'none',
              border: 'none',
              padding: 0,
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            {t('menu.employees')}
          </Link>
          <Typography
            variant="body2"
            sx={{ fontSize: theme.typography.employeeName.fontSize, color: theme.palette.text.body, fontWeight: theme.typography.fontWeightBold }}
          >
            {employeeName}
          </Typography>
        </Breadcrumbs>
      </Box>
    </Box>
  );
}
